import { RootState } from "PROCUREMENTTypes";
import { Maybe } from "tsmonad";
import { SessionReducerState } from '../../redux/reducers/session';

export const getSession = (state: RootState): SessionReducerState => state.session;

export const getSapCustomerNumber = (state: RootState): Maybe<string> => Maybe.maybe(getSession(state).sapCustomerNumber);
